import React from 'react'
import { css, StyleSheet } from 'aphrodite'

const COMPANY = 'iAgro'
const SUPPORT_EMAIL = 'support@iagro.uz'
const UPDATED = '2026-yil 7-iyun'

export default function Privacy() {
    return (
        <div className={css(styles.page)}>
            <div className={css(styles.container)}>
                <h1 className={css(styles.title)}>Maxfiylik siyosati</h1>
                <p className={css(styles.updated)}>Oxirgi yangilanish: {UPDATED}</p>

                <Section title="1. Kirish">
                    <p className={css(styles.p)}>
                        {COMPANY} ("biz", "ilova") ushbu maxfiylik siyosati orqali
                        foydalanuvchilarning shaxsiy maʼlumotlarini qanday yig'ishimiz,
                        ishlatishimiz, saqlashimiz va himoya qilishimizni tushuntiradi.
                        Ilovadan foydalanish orqali siz ushbu siyosatga rozilik bildirasiz.
                    </p>
                </Section>

                <Section title="2. Biz yig'adigan maʼlumotlar">
                    <p className={css(styles.p)}>Ilova quyidagi maʼlumotlarni yig'adi:</p>
                    <ul className={css(styles.list)}>
                        <li><b>Hisob maʼlumotlari:</b> ism, familiya, elektron pochta manzili va parol (ro'yxatdan o'tish uchun).</li>
                        <li><b>Moliyaviy maʼlumotlar:</b> siz kiritgan kirim/chiqim yozuvlari, summalar, kategoriyalar, izohlar va xodimlar oyliklari haqidagi maʼlumotlar.</li>
                        <li><b>Texnik maʼlumotlar:</b> ilovaning to'g'ri ishlashi uchun zarur bo'lgan sessiya tokeni.</li>
                    </ul>
                    <p className={css(styles.p)}>
                        Ilova joylashuv, kamera, kontaktlar yoki boshqa qurilma sensorlaridan
                        foydalanmaydi va bunday maʼlumotlarni yig'maydi.
                    </p>
                </Section>

                <Section title="3. Maʼlumotlardan foydalanish">
                    <p className={css(styles.p)}>Yig'ilgan maʼlumotlar faqat quyidagi maqsadlarda ishlatiladi:</p>
                    <ul className={css(styles.list)}>
                        <li>Hisobingizni yaratish va autentifikatsiya qilish;</li>
                        <li>Moliyaviy yozuvlaringizni saqlash va ko'rsatish;</li>
                        <li>Balans va hisobotlarni hisoblash;</li>
                        <li>Ilova xizmatini taʼminlash va yaxshilash.</li>
                    </ul>
                </Section>

                <Section title="4. Maʼlumotlarni uchinchi tomonlarga berish">
                    <p className={css(styles.p)}>
                        Biz sizning shaxsiy yoki moliyaviy maʼlumotlaringizni uchinchi
                        tomonlarga sotmaymiz va reklama maqsadlarida bermaymiz. Maʼlumotlar
                        faqat qonun talab qilgan hollarda yoki xizmatni taʼminlash uchun
                        zarur boʼlganda ishlatiladi.
                    </p>
                </Section>

                <Section title="5. Maʼlumotlar xavfsizligi">
                    <p className={css(styles.p)}>
                        Maʼlumotlar server bilan shifrlangan HTTPS aloqasi orqali uzatiladi.
                        Kirish tokeni qurilmada shifrlangan saqlash (iOS Keychain / Android
                        EncryptedSharedPreferences) yordamida himoyalanadi.
                    </p>
                </Section>

                <Section title="6. Maʼlumotlarni saqlash muddati">
                    <p className={css(styles.p)}>
                        Maʼlumotlaringiz hisobingiz faol boʼlgunicha saqlanadi. Hisobingizni
                        oʼchirsangiz, unga bogʼliq shaxsiy va moliyaviy maʼlumotlar tizimdan
                        oʼchiriladi.
                    </p>
                </Section>

                <Section title="7. Hisobni oʼchirish">
                    <p className={css(styles.p)}>
                        Siz istalgan vaqtda ilova ichida <b>Sozlamalar → Akkauntni oʼchirish</b>
                        boʼlimi orqali hisobingizni va unga bogʼliq maʼlumotlarni butunlay
                        oʼchirishingiz mumkin. Bu amalni ortga qaytarib boʼlmaydi.
                    </p>
                </Section>

                <Section title="8. Foydalanuvchi huquqlari">
                    <p className={css(styles.p)}>
                        Siz oʼz maʼlumotlaringizni koʼrish, tahrirlash va oʼchirish huquqiga
                        egasiz. Savollar boʼlsa, biz bilan bogʼlaning.
                    </p>
                </Section>

                <Section title="9. Bogʼlanish">
                    <p className={css(styles.p)}>
                        Maxfiylik siyosati boʼyicha savollaringiz boʼlsa, quyidagi manzilga
                        yozing: <a className={css(styles.link)} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    </p>
                </Section>

                <p className={css(styles.footer)}>© 2026 {COMPANY}. Barcha huquqlar himoyalangan.</p>
            </div>
        </div>
    )
}

function Section({ title, children }) {
    return (
        <div className={css(styles.section)}>
            <h2 className={css(styles.h2)}>{title}</h2>
            {children}
        </div>
    )
}

const styles = StyleSheet.create({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '2rem 1rem',
    },
    container: {
        maxWidth: '760px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '2.5rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        color: '#0f172a',
        lineHeight: 1.7,
    },
    title: {
        fontSize: '2rem',
        fontWeight: 700,
        margin: '0 0 0.25rem',
        color: '#D97757',
    },
    updated: { fontSize: '0.9rem', color: '#64748b', margin: '0 0 1.5rem' },
    section: { marginBottom: '1.5rem' },
    h2: { fontSize: '1.2rem', fontWeight: 600, margin: '0 0 0.5rem' },
    p: { fontSize: '1rem', margin: '0 0 0.5rem' },
    list: { fontSize: '1rem', paddingLeft: '1.25rem', margin: '0 0 0.5rem' },
    link: { color: '#D97757', textDecoration: 'none' },
    footer: { marginTop: '2rem', fontSize: '0.85rem', color: '#94a3b8', textAlign: 'center' },
})
